<div class="container">
    <div class="card">
        <div class="header">
            <div class="icon" [innerHTML]="authIcon"></div>
            <h2 class="title">{{ title }}</h2>
        </div>
        <ng-content></ng-content>
    </div>
</div>
